import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { colors } from "../theme/designSystem";

interface SavingOverlayProps {
  open: boolean;
  message?: string;
}

// Overlay padrão "Processando" para modais de salvamento (padrão de sistema).
// Renderizar como primeiro filho do <Dialog>; o Paper precisa de position:relative e overflow:hidden
// (PaperProps={{ sx: { position: "relative", overflow: "hidden" } }}).
const SavingOverlay: React.FC<SavingOverlayProps> = ({
  open,
  message = "Processando...",
}) => {
  if (!open) return null;
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 10,
        backgroundColor: "rgba(255,255,255,0.72)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
      }}
    >
      <CircularProgress sx={{ color: colors.primary }} />
      <Typography sx={{ fontWeight: 600, color: colors.primary }}>
        {message}
      </Typography>
    </Box>
  );
};

export default SavingOverlay;
